import React, { useState, useEffect, useCallback, useRef, useContext } from 'react';
import { BodyHeader } from './bodyHeader/bodyHeader';
import './rateCardBody.scss';
import { IS_MULTIPLE_SORT, MEDIA_OPTIONS, paginationLength, PRODUCT_OPTIONS, TABLE_HEADERS } from 'rateCard/constant/constant';
import TableLoader from 'home/view/manage-feasibility/components/organisms/addressProcessAOI/loader/table-loader';
import { fetchContentsForRateCard } from 'rateCard/services/rateCard.service';
import { findParamFromUrl, handleError } from 'common/utils/app.utils';
import { IDropDown, IRecordRequest, ITableRecords } from 'rateCard/constant/rateCard.interface';
import { getFilterOptions, isStandardRate, mapToTableContent } from 'rateCard/services/rateCardMapper';
import { Filters } from './filters/Filters';
import debounce from 'lodash.debounce';
import { AppContext } from 'App';
import { fireAnalyitcsOnProductChange } from 'rateCard/analytics/analytics';
import { CustomTable } from 'common/components/table/table';
import { prepareSortModel } from 'common/components/table/table.constant';

export const RateCardBody = () => {
  const [product, setProduct] = useState<IDropDown>(PRODUCT_OPTIONS[0]);
  const [media, setMedia] = useState<IDropDown>(MEDIA_OPTIONS[0]);
  const [records, setRecords] = useState<ITableRecords>({ content: [], totalElement: 0, totalPages: 0 });
  const [totalRecords, setTotalRecords] = useState<ITableRecords>({ content: [], totalElement: 0, totalPages: 0 });
  const [isLoading, setIsLoading] = useState(true);
  const [resetFilters, setResetFilters] = useState<boolean>(false);
  let [isProductNotChanged, setIsProductNotChanged] = useState(true);
  const { setIsAuthJourney } = useContext(AppContext) || { setIsAuthJourney: (a: boolean) => {} };
  const onCellClickHandler = () => {};
  const partyId = findParamFromUrl('partyId');
  const requestParams = useRef<IRecordRequest>({});

  const setAuthDetails = () => {
    setIsAuthJourney?.(true);
  };

  const fetchRecordsFn = ({ sortModel = {}, page = 1, size = 10, product, status, serviceType, bandwidth, isFetchingAllRecords }: IRecordRequest) => {
    setIsLoading(true);
    setIsProductNotChanged(true);
    const params: IRecordRequest = {
      ...requestParams.current,
      page: page - 1,
      size,
      ...sortModel,
      partyId,
      product,
      mediaType: media?.key,
      serviceType: serviceType?.toString() ? serviceType : requestParams.current?.serviceType,
      bandwidth: bandwidth?.toString() ? bandwidth : requestParams.current?.bandwidth,
      status: status?.toString() ? status : requestParams.current?.status
    };

    fetchContentsForRateCard(params).then(
      ({ data: { result } }: { data: { result: ITableRecords } }) => {
        setIsLoading(false);
        setAuthDetails();
        requestParams.current = { ...params };
        if (isFetchingAllRecords) {
          setTotalRecords(result);
        } else {
          setRecords(result);
        }
      },
      (err: any) => {
        setIsLoading(false);
        handleError(err as any);
      }
    );
  };

  const fetchRecords = useCallback(debounce(fetchRecordsFn, 100), [media]);

  const onTableStateChange = ({ sort, currentPage, showRows, activeColumn }: any) => {
    fetchRecords({ sortModel: prepareSortModel(sort, activeColumn, IS_MULTIPLE_SORT), page: currentPage, size: showRows, product: product?.key });
  };

  const onFilterChange = (filters: { bandwidth: string; serviceType: string; status: string }) => {
    requestParams.current = filters;
    fetchRecords({ ...filters, product: product?.key });
  };

  const onClearFilter = ({ setShowRows, setCurrentPage }: { setShowRows: Function; setCurrentPage: Function }) => {
    setResetFilters(!resetFilters);
    requestParams.current = {};
    setShowRows?.(10);
    setCurrentPage?.(1);
  };

  const onResetClikced = () => {
    requestParams.current = {};
    setIsProductNotChanged(false);
    fetchRecords({ product: product?.key });
  };

  const fetchTotalRecords = () => {
    setTimeout(() => {
      fetchRecords({ product: product?.key, size: 10000, isFetchingAllRecords: true });
    }, 100);
  };

  const onProductChanged = (product: IDropDown) => {
    setProduct(product);
    fireAnalyitcsOnProductChange(product.key);
  };

  useEffect(() => {
    setIsProductNotChanged(false);
    fetchRecords({ product: product?.key });
    setResetFilters(!resetFilters);
    fetchTotalRecords();
  }, [product]);

  useEffect(() => {
    if (product?.key) {
      fetchRecords({ product: product?.key });
    }
  }, [media]);

  return (
    <div className="container1">
      <div className="rate_card_body">
        <div className="card">
          <BodyHeader product={product} setProduct={onProductChanged} media={media} setMedia={setMedia} isStandardRate={isStandardRate(totalRecords?.content)} />
          <Filters
            onResetClikced={onResetClikced}
            onFilterChange={onFilterChange}
            resetFilters={resetFilters}
            options={getFilterOptions(mapToTableContent(totalRecords?.content))}
          />
          {isProductNotChanged && (
            <CustomTable
              loader={<TableLoader />}
              renderHeaderSection={() => {}}
              showLoader={isLoading}
              headers={TABLE_HEADERS}
              contents={mapToTableContent(records?.content)}
              onCellClickHandler={onCellClickHandler}
              totalPages={records?.totalPages}
              totalRecords={records?.totalElement}
              onChange={onTableStateChange}
              showSearch={false}
              multipleSort={false}
              onClearFilter={onClearFilter}
              paginationLength={paginationLength}
              renderMessage={() => {}}
              onSortChange={() => {}}
              onPageChange={() => {}}
            />
          )}
        </div>
      </div>
    </div>
  );
};
